import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class EnvCdssQaService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: false,
      isMagellan: '1',
      _env: 'cdss-qa',
      _apiUrl: 'https://qa3-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://qa3-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer: 'https://cdssqa1adb2c.b2clogin.com/b6b06fa0-cc24-46e6-92a7-57abacdb8a2e/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint: 'https://cdssqa1adb2c.b2clogin.com/cdssqa1adb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl: 'https://cdssqa1adb2c.b2clogin.com/cdssqa1adb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: 'd0e44db6-6f5a-4b5b-853a-3fcfd4b06ac7',
      _scope: 'openid profile https://cdssqa1adb2c.onmicrosoft.com/qa3-api/cdss.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl:
        'https://cdssqa1adb2c.b2clogin.com/cdssqa1adb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://qa3-login.p-cis.com/',
      _signInURL:
        'https://cdssqa1adb2c.b2clogin.com/cdssqa1adb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO:
        'https://cdssqa1adb2c.b2clogin.com/cdssqa1adb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl:
        'https://cdssqa1adb2c.b2clogin.com/cdssqa1adb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink:
        'https://cdssqa1adb2c.b2clogin.com/cdssqa1adb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _oktaClientId: '0oahk1rvhlKf8rxnC4h7',
      _oktaIssuer: 'https://login.3.cares.cwds.ca.gov/oauth2/aushk1u714bDLo4HB4h7',
      _oktaRedirectUri: 'https://qa3-login.p-cis.com/auth/okta/callback',
      _authEndpoint:
        'https://cdssqa1adb2c.b2clogin.com/cdssqa1adb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://cdssqa1adb2c.b2clogin.com/cdssqa1adb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9aaf',
      _intercomAppId: 'bqgvwybf'
    
      };
  }
}
